/**
 * Currency törzs FE wrapper — read-only a FE-en, a CRUD a FEA-ban marad.
 *
 * BE: GET /currencies?activeOnly=false
 */

import type { Currency } from '@pta/types';
import { apiCall } from './client';

export function fetchCurrencies(params?: {
  activeOnly?: boolean;
}): Promise<Currency[]> {
  return apiCall('/currencies', {
    query: {
      // Default BE viselkedés: activeOnly=true. Csak akkor küldjük a query
      // paramétert, ha explicit false-t akarunk.
      activeOnly: params?.activeOnly === false ? 'false' : undefined,
    },
  });
}
